import axios from 'axios';

/**
 * Fetch API subscriptions with optional filters.
 *
 * @param {Object} params
 * @return {Promise}
 */
export const fetchApiSubscriptionsAPI = (params = {}) => {
    return axios({
        method: 'get',
        url: '/v2/api-gateway/api-subscriptions',
        params,
    });
};

/**
 * Fetch available REST APIs for the API Gateway dropdown.
 *
 * @param {string} name
 * @return {Promise}
 */
export const fetchAvailableRestApisAPI = ({ name } = {}) => {
    return axios({
        method: 'get',
        url: `v2/api-gateway/rest-apis?name=${name}`,
    });
};

/**
 * Fetch Usage Plans List
 *
 * @param {Object} params
 * @return {Promise}
 */
export const fetchUsagePlansListAPI = params => {
    return axios({
        method: 'get',
        url: '/v2/api-gateway/usage-plans',
        params,
    });
};

/**
 * Update Usage Plan for a specific API
 *
 * @param {Object} updatedUsagePlanInfo
 * @return {Promise}
 */
export const updateUsagePlanForApiAPI = ({ updatedUsagePlanInfo }) => {
    return axios({
        method: 'patch',
        url: '/v2/api-gateway/usage-plans/subscribe',
        data: updatedUsagePlanInfo,
    });
};

/**
 * Fetch Analytics Overview
 *
 * @param {Object} params
 * @return {Promise}
 */
export const fetchAnalyticsOverviewAPI = (params = {}) => {
    return axios({
        method: 'get',
        url: '/v2/api-gateway/analytics/overview',
        params,
    });
};

/**
 * Fetch Partner Usage Summary
 *
 * @param {Object} params
 * @return {Promise}
 */
export const fetchPartnerUsageSummaryAPI = (params = {}) => {
    return axios({
        method: 'get',
        url: '/v2/api-gateway/analytics/usage/summary',
        params,
    });
};
